import {
  VETERAN_TYPE_MILITARY,
  VETERAN_TYPE_NATIONAL_GUARD,
} from '@nerdwallet/home-constants';

export const LOAN_TERM_30_YEAR = {
  label: '30 year',
  value: 30,
};

export const LOAN_TERM_15_YEAR = {
  label: '15 year',
  value: 15,
};

export const loanTerms = [LOAN_TERM_30_YEAR, LOAN_TERM_15_YEAR];

export const NOT_A_VETERAN_OPTION = {
  label: 'No',
  value: '',
};
export const VETERAN_TYPE_MILITARY_OPTION = {
  label: 'Yes, regular military',
  value: VETERAN_TYPE_MILITARY,
};
export const VETERAN_TYPE_NATIONAL_GUARD_OPTION = {
  label: 'Yes, national guard',
  value: VETERAN_TYPE_NATIONAL_GUARD,
};
export const veteranOptions = [
  NOT_A_VETERAN_OPTION,
  VETERAN_TYPE_MILITARY_OPTION,
  VETERAN_TYPE_NATIONAL_GUARD_OPTION,
];

export const firstVaLoanOption = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];
